import httpClient from '@/http-client'
import { baseMutations, baseState } from '@/store/mixins'

const BASE_URL = '/api/v2/payment/exchange-rates'

export default {
  namespaced: true,
  state: {
    ...baseState
  },
  mutations: {
    ...baseMutations
  },
  actions: {
    async fetch(context, attrubutes = {}) {
      let params = Object.assign(
        {
          page: context.state.pagination.page,
          perPage: context.state.pagination.perPage,
          search: context.state.search
        },
        attrubutes
      )
      let response = await httpClient.get(`${BASE_URL}`, {
        params
      })
      context.commit('RECEIVE_RESOURCES', response.data)
      return response
    },
    onGetCurrency(context) {
      return httpClient.get(`${BASE_URL}/currencies`);
    },
    onSave(context, data) {
      return httpClient.post(`${BASE_URL}`, data)
    },
    onDelete(context, id) {
      return httpClient.delete(`${BASE_URL}/${id}`)
    }
  }
}
